module.exports = __webpack_public_path__ + "static/media/nima-look.79648a3e.png";